import io from 'socket.io-client';
export const connection = {
  socket: null,
  hash: null
};
function createSocketConnection(hash, navigate, listeners) {
  const socketConnection = io(window.location.origin, {
    // drawings-v1: send each drawing once, then only new ones (src/utils/drawingPayload.js).
    query: {
      hash,
      caps: 'drawings-v1'
    },
    transports: ['websocket', 'polling']
  });
  socketConnection.on('connect_error', () => {
    socketConnection.io.opts.transports = ['polling'];
    socketConnection.connect();
  });
  connection.socket = socketConnection;
  connection.hash = hash;
  listeners.forEach(listener => {
    const {
      name,
      cb
    } = listener;
    connection.socket.on(name, cb);
  });
  connection.socket.on('error', error => {
    console.error(error);
  });
  return socketConnection;
}
export default function socket(hash, navigate, listeners, forceRefresh, onNewConnection) {
  if (connection.hash !== hash || forceRefresh) {
    if (connection.socket) {
      connection.socket.disconnect();
    }
    onNewConnection();
    return createSocketConnection(hash, navigate, listeners);
  }
  return connection.socket;
}